import React from 'react';
import {Link, NavLink} from 'react-router-dom';
import './navbar.scss';

const Navbar =  () => {
    return (
        <div className="container nav navbar navbar-dark bg-custom p-5">
            <div className="logo-container">
                <Link className="navbar-brand logo-jacx" to="/"> JACX</Link>
            </div>
            <div>
                <div className="d-flex">
                    <NavLink className="btn text-white mr-2" to="/" exact>
                        Inicio
                    </NavLink>
                    <NavLink className="btn mr-2 text-white" to="/portafolio">
                        Portfolio
                    </NavLink>
                    <NavLink className="btn mr-2 text-white" to="/blog">
                        Blog
                    </NavLink>
                </div>
            </div>
        </div>
    )
}

export default Navbar;